let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1D6DH"), load("eEBx4")]).then(() => parcelRequire('cuPHJ'));